import { useQuery } from "react-query";
import { jobTitlesApi, type JobTitle } from "@/lib/api/job-titles";

export const JOB_TITLES_QUERY_KEY = ["job-titles"] as const;

export function useJobTitles(includeInactive = true, options?: { enabled?: boolean }) {
  return useQuery<JobTitle[]>(
    [...JOB_TITLES_QUERY_KEY, includeInactive],
    () => jobTitlesApi.getAll(includeInactive),
    { staleTime: 60 * 60 * 1000, enabled: options?.enabled ?? true }
  );
}
